import React from 'react';
import { Box } from '@apia/theme';
import { TResponsiveTableCellRendererProps } from '../types';
import { TAccordionCellRenderer } from './AccordionCell';

const NoMemoAccordionHTMLCellRenderer: TAccordionCellRenderer<{
  html: string;
}> = React.forwardRef<
  HTMLSpanElement,
  TResponsiveTableCellRendererProps<{ html: string }>
>(
  (
    {
      cell: { children, Renderer, rendererProps, AccordionRenderer, ...cell },
      column,
      row,
      ...props
    },
    currentRef,
  ) => (
    <Box>
      {(column.label || column.name) && (
        <Box as="strong">{column.label ?? column.name}: </Box>
      )}
      <Box
        ref={currentRef as React.RefObject<HTMLTableCellElement>}
        {...props}
        {...cell}
        className="accordion__cell__renderer"
        dangerouslySetInnerHTML={{
          __html: String(rendererProps?.html ?? children ?? '').replaceAll(
            /<TOK(\d+)/g,
            '&lt;TOK$1',
          ),
        }}
        as="span"
      />
    </Box>
  ),
);

NoMemoAccordionHTMLCellRenderer.displayName = 'AccordionHTMLCellRenderer';

export const AccordionHTMLCellRenderer = NoMemoAccordionHTMLCellRenderer;
